import React, { useState } from "react";
import {
  Box,
  useTheme,
  FormControl,
  TextField,
  Autocomplete,
  Grid,
  Paper,
  TextareaAutosize,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import { Typography } from "../../common/Typography/Typography";
import { Button } from "../../common/Button/Button";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SelectJobModal } from "./SelectJobModal";
import { OffPlateformTransformationEngineModal } from "./OffPlateformTransformationEngineModal";
import { SimpleLoader } from "../../common/Loader/Loader";
import { DOCLink } from "../../common/Link/Link";
import { Alert } from "../../common/Alert";
import { OffPlatformIcon } from "../../common/Icons/OffPlatformIcon";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  CreateTransformationDocument,
  TransformationMethod,
} from "../../generated";
import { useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { CustomTextArea } from "../../common/CustomTextArea/CustomTextArea";
import { CustomTextField } from "../../common/CustomTextField/CustomTextField";
import { Label } from "../../common/Label/Label";

const jobsData: string | any[] = [
  {
    name: "Job Name",
    key: "870492da-ecfb-4be0-91b9-9a89ddd3db90",
  },
];

export const CreateTransformation = ({
  toggleRightSidePanel,
  showToast,
}: {
  toggleRightSidePanel: any;
  showToast: any;
}) => {
  const { palette } = useTheme();
  const [toggleSelectJob, setToggleSelectJob] = useState(false);
  const [show, setShow] = useState(false);
  const [
    toggleOffPlateformTransformation,
    setToggleOffPlateformTransformation,
  ] = useState(false);
  const { projectId, workspaceId } = useParams();
  const [mutate] = useMutation(CreateTransformationDocument);

  return (
    <Formik
      validationSchema={Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required(),
        transformationMethod: Yup.string().required(),
        sourceUrl: Yup.string().required(),
      })}
      initialValues={{
        name: "",
        description: "",
        transformationMethod: "",
        sourceUrl: "",
      }}
      onSubmit={async (values) => {
        await mutate({
          variables: {
            input: {
              description: values.description,
              name: values.name,
              projectId: projectId || "",
              workspaceId: workspaceId || "",
              sourceUrl: values.sourceUrl || "",
              transformationMethod:
                values.transformationMethod as TransformationMethod,
            },
          },
          refetchQueries: ["getWorkflow"],
        });
        toggleRightSidePanel(false);
        showToast("Transformation added");
      }}
    >
      {({ handleChange, errors, touched, handleSubmit, values }) => (
        <Box
          boxSizing="border-box"
          sx={{
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Box
              sx={{
                paddingRight: "20px",
                paddingBottom: "16px",
                borderBottom: `1px solid ${palette.outline}`,
              }}
              mb={6}
            >
              <Typography
                mb={2}
                variant="h5"
                color={palette.gray.dark}
                sx={{
                  fontSize: "12px",
                  lineHeight: "14px",
                  textTransform: "uppercase",
                  fontWeight: "700",
                }}
              >
                Transformation
              </Typography>
              <Typography
                mb={4}
                variant="h5"
                color={palette.common.black}
                sx={{ wordBreak: "break-word" }}
              >
                New Transformation
              </Typography>
              {/* <Chip
                icon={getIssueIcon(IssueStatus.Major)}
                color={getIssueColor(IssueStatus.Major)}
                label={getLabelIssueStatus(IssueStatus.Major)}
                sx={{
                  color: palette.common.black,
                  fontSize: "12px",
                  lineHeight: "16px",
                  fontWeight: "500",
                }}
              /> */}
            </Box>

            <Box boxSizing="border-box">
              <Box
                sx={{
                  paddingRight: "20px",
                  paddingBottom: "16px",
                  borderBottom: `1px solid ${palette.outline}`,
                }}
                mb={6}
              >
                {" "}
                <Box
                  sx={{
                    paddingBottom: "16px",
                    borderBottom: `1px solid ${palette.outline}`,
                  }}
                  mb={6}
                >
                  {show && (
                    <Box
                      mb={4}
                      sx={{
                        background: palette.settings.lighter,
                        borderRadius: "4px",
                        padding: "20px",
                        "> .MuiBox-root": {
                          width: "100%",
                        },
                      }}
                    >
                      <SimpleLoader
                        text="Finding jobs..."
                        className="custom-loader"
                        customTextClass="custom-text"
                      />
                    </Box>
                  )}
                  <Typography
                    mb={2}
                    variant="h6"
                    color={palette.common.black}
                    sx={{ fontWeight: "400" }}
                  >
                    About
                  </Typography>
                  <Box mb={6} display="flex" flexDirection="column">
                    <Typography
                      variant="body1"
                      mb={2}
                      fontSize="0.875rem"
                      fontWeight={500}
                      color={palette.common.black}
                    >
                      Transformation name
                    </Typography>

                    <CustomTextField
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      error={errors.name}
                      touched={touched.name}
                    />
                  </Box>
                  <Box mb={6} display="flex" flexDirection="column">
                    <Typography
                      variant="body1"
                      mb={2}
                      fontSize="0.875rem"
                      fontWeight={500}
                      color={palette.common.black}
                    >
                      Transformation description
                    </Typography>

                    <CustomTextArea
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                      error={errors.description}
                      touched={touched.description}
                    />
                  </Box>
                </Box>
                <Typography
                  mb={2}
                  variant="h6"
                  color={palette.common.black}
                  sx={{ fontWeight: "400" }}
                >
                  Transformation method
                </Typography>
                <Box
                  mb={3}
                  display="flex"
                  flexDirection="column"
                  sx={{
                    ".MuiFormControlLabel-root": {
                      alignItems: "flex-start",
                      margin: "0 0 12px -16px",
                    },
                    ".MuiRadio-root": {
                      paddingTop: "0",
                    },
                    ".Mui-checked + span .label-title": {
                      fontWeight: 500,
                    },
                  }}
                >
                  <FormControl>
                    <Typography
                      variant="body1"
                      mb={2}
                      fontSize="0.875rem"
                      fontWeight={500}
                      color={palette.common.black}
                    >
                      Method
                    </Typography>
                    <RadioGroup
                      defaultValue="platform"
                      name="transformationMethod"
                      value={values.transformationMethod}
                      onChange={handleChange}
                    >
                      <FormControlLabel
                        value="DBT_CLOUD"
                        control={<Radio />}
                        label={
                          <>
                            <Typography
                              variant="body1"
                              mb={2}
                              fontSize="1rem"
                              lineHeight="1"
                              fontWeight={400}
                              className="label-title"
                              color={palette.common.black}
                            >
                              Brighthive-managed dbt Cloud
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize="0.875rem"
                              lineHeight="1.2"
                              fontWeight={400}
                              color={palette.gray.darkest}
                            >
                              Securely transform data using engines private to
                              this workspace. This means your data never leaves
                              the workspace.
                            </Typography>
                          </>
                        }
                      />
                      {errors.transformationMethod &&
                        touched.transformationMethod && (
                          <FormHelperText
                            style={{
                              color: palette.error.dark,
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              lineHeight: "20px",
                              fontWeight: 400,
                            }}
                          >
                            {errors.transformationMethod}
                          </FormHelperText>
                        )}
                      {/* <FormControlLabel
                        value={TransformationMethod.OnPlatform}
                        control={<Radio />}
                        label={
                          <>
                            <Typography
                              variant="body1"
                              mb={2}
                              fontSize="1rem"
                              lineHeight="1"
                              fontWeight={400}
                              className="label-title"
                              color={palette.common.black}
                            >
                              On platform
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize="0.875rem"
                              lineHeight="1.2"
                              fontWeight={400}
                              color={palette.gray.darkest}
                            >
                              Securely transform data using engines private to
                              this workspace. This means your data never leaves
                              the workspace.
                            </Typography>
                          </>
                        }
                      />
                      <FormControlLabel
                        value={TransformationMethod.OffPlatform}
                        control={<Radio />}
                        label={
                          <>
                            <Typography
                              variant="body1"
                              mb={2}
                              fontSize="1rem"
                              lineHeight="1"
                              fontWeight={400}
                              className="label-title"
                              color={palette.common.black}
                            >
                              Off platform (connected)
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize="0.875rem"
                              lineHeight="1.2"
                              fontWeight={400}
                              color={palette.gray.darkest}
                            >
                              Transform data off-platform using external engines
                              managed by an approved workspace organization.
                            </Typography>
                          </>
                        }
                      />
                      <FormControlLabel
                        value={TransformationMethod.OtherRepository}
                        control={<Radio />}
                        label={
                          <>
                            <Typography
                              variant="body1"
                              mb={2}
                              fontSize="1rem"
                              lineHeight="1"
                              fontWeight={400}
                              className="label-title"
                              color={palette.common.black}
                            >
                              Off platform (not connected)
                            </Typography>
                            <Typography
                              variant="body1"
                              fontSize="0.875rem"
                              lineHeight="1.2"
                              fontWeight={400}
                              color={palette.gray.darkest}
                            >
                              Use your own code repository without integration.
                              No job information will be available.
                            </Typography>
                          </>
                        }
                      /> */}
                    </RadioGroup>
                  </FormControl>
                </Box>
                {/* <Divider /> */}
                {show && (
                  <>
                    <Box
                      mb={4}
                      sx={{
                        background: palette.settings.lighter,
                        borderRadius: "4px",
                        padding: "20px",
                      }}
                    >
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.common.black}
                      >
                        Transformation template
                      </Typography>
                      <Button
                        color="grayAccent"
                        variant="contained"
                        onClick={() =>
                          setToggleOffPlateformTransformation(true)
                        }
                      >
                        Select template
                      </Button>
                    </Box>

                    <Alert
                      severity="warning"
                      sx={{
                        marginBottom: "16px",
                      }}
                    >
                      Please ensure use of external transformation methods
                      complies with workspace data use policies.
                    </Alert>
                    <Box
                      mb={4}
                      sx={{
                        background: palette.settings.lighter,
                        borderRadius: "4px",
                        padding: "20px",
                      }}
                    >
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.common.black}
                      >
                        Transformation template
                      </Typography>
                      <Box sx={{ position: "relative" }}>
                        <Button
                          color="grayAccent"
                          variant="outlined"
                          sx={{
                            position: "absolute",
                            left: "7px",
                            top: "17px",
                            border: "none !important",
                            boxShadow: "none !important",
                            padding: "0 !important",
                            pointerEvents: "none",
                            minWidth: "inherit",
                          }}
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.2771 0.217773C7.82938 0.217773 8.2771 0.665489 8.2771 1.21777C8.2771 1.48299 8.38246 1.73734 8.56999 1.92488C8.75753 2.11242 9.01188 2.21777 9.2771 2.21777C9.82938 2.21777 10.2771 2.66549 10.2771 3.21777C10.2771 3.77006 9.82938 4.21777 9.2771 4.21777C9.01188 4.21777 8.75753 4.32313 8.56999 4.51067C8.38246 4.6982 8.2771 4.95256 8.2771 5.21777C8.2771 5.77006 7.82938 6.21777 7.2771 6.21777C6.72481 6.21777 6.2771 5.77006 6.2771 5.21777C6.2771 4.95256 6.17174 4.6982 5.98421 4.51067C5.79667 4.32313 5.54232 4.21777 5.2771 4.21777C4.72481 4.21777 4.2771 3.77006 4.2771 3.21777C4.2771 2.66549 4.72481 2.21777 5.2771 2.21777C5.54232 2.21777 5.79667 2.11242 5.98421 1.92488C6.17174 1.73734 6.2771 1.48299 6.2771 1.21777C6.2771 0.665489 6.72481 0.217773 7.2771 0.217773ZM15.57 0.510667C15.9605 0.120142 16.5937 0.120142 16.9842 0.510667L19.9842 3.51067C20.3747 3.90119 20.3747 4.53436 19.9842 4.92488L4.98421 19.9249C4.59368 20.3154 3.96052 20.3154 3.56999 19.9249L0.569993 16.9249C0.179469 16.5344 0.179469 15.9012 0.569993 15.5107L12.5698 3.51087L15.57 0.510667ZM13.2771 5.63199L2.69131 16.2178L4.2771 17.8036L14.8629 7.21777L13.2771 5.63199ZM16.2771 5.80356L14.6913 4.21777L16.2771 2.63199L17.8629 4.21777L16.2771 5.80356ZM17.2771 10.2178C17.8294 10.2178 18.2771 10.6655 18.2771 11.2178C18.2771 11.483 18.3825 11.7373 18.57 11.9249C18.7575 12.1124 19.0119 12.2178 19.2771 12.2178C19.8294 12.2178 20.2771 12.6655 20.2771 13.2178C20.2771 13.7701 19.8294 14.2178 19.2771 14.2178C19.0119 14.2178 18.7575 14.3231 18.57 14.5107C18.3825 14.6982 18.2771 14.9526 18.2771 15.2178C18.2771 15.7701 17.8294 16.2178 17.2771 16.2178C16.7248 16.2178 16.2771 15.7701 16.2771 15.2178C16.2771 14.9526 16.1717 14.6982 15.9842 14.5107C15.7967 14.3231 15.5423 14.2178 15.2771 14.2178C14.7248 14.2178 14.2771 13.7701 14.2771 13.2178C14.2771 12.6655 14.7248 12.2178 15.2771 12.2178C15.5423 12.2178 15.7967 12.1124 15.9842 11.9249C16.1717 11.7373 16.2771 11.483 16.2771 11.2178C16.2771 10.6655 16.7248 10.2178 17.2771 10.2178Z"
                              fill={palette.grayAccent.light}
                            />
                          </svg>
                        </Button>
                        <Autocomplete
                          id="schema-template"
                          freeSolo
                          defaultValue={
                            "Dual Enrollment Registered Students" || []
                          }
                          onChange={(_, value) => {}}
                          options={["Template1, Template2, Template3"] || []}
                          renderInput={(params) => <TextField {...params} />}
                          sx={{
                            width: "100%",
                            background: palette.common.white,
                            ".MuiInputBase-input": {
                              width: "100%",
                              height: "36px",
                              fontSize: "16px",
                              lineHeight: "20px",
                              padding: "8px",
                              paddingLeft: "30px !important",
                              boxSizing: "border-box",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                    <Box
                      mb={4}
                      sx={{
                        background: palette.settings.lighter,
                        borderRadius: "4px",
                        padding: "20px",
                      }}
                    >
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.common.black}
                      >
                        Configured transformation engine
                      </Typography>
                      <Box sx={{ position: "relative" }}>
                        <Button
                          color="grayAccent"
                          variant="outlined"
                          sx={{
                            position: "absolute",
                            left: "7px",
                            top: "17px",
                            border: "none !important",
                            boxShadow: "none !important",
                            padding: "0 !important",
                            pointerEvents: "none",
                            minWidth: "inherit",
                          }}
                        >
                          <OffPlatformIcon />
                        </Button>
                        <Autocomplete
                          id="schema-template"
                          freeSolo
                          defaultValue={
                            "Dual Enrollment Registered Students" || []
                          }
                          onChange={(_, value) => {}}
                          options={["Nickname, Nickname, Nickname"] || []}
                          renderInput={(params) => <TextField {...params} />}
                          sx={{
                            width: "100%",
                            background: palette.common.white,
                            ".MuiInputBase-input": {
                              width: "100%",
                              height: "36px",
                              fontSize: "16px",
                              lineHeight: "20px",
                              padding: "8px",
                              paddingLeft: "30px !important",
                              boxSizing: "border-box",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  </>
                )}
              </Box>

              {show && (
                <Box
                  sx={{
                    paddingBottom: "16px",
                    borderBottom: `1px solid ${palette.outline}`,
                  }}
                  mb={6}
                >
                  <Typography
                    mb={4}
                    variant="h5"
                    color={palette.common.black}
                    sx={{
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: "normal",
                    }}
                  >
                    Jobs
                  </Typography>

                  <Box>
                    <Grid container>
                      {jobsData && jobsData.length > 0 ? (
                        <>
                          {jobsData.map((job) => (
                            <Grid
                              item
                              xs={12}
                              mb={4}
                              sx={{ minWidth: "360px" }}
                            >
                              <Paper
                                variant="outlined"
                                sx={{
                                  p: 4,
                                  display: "flex",
                                  minHeight: "100%",
                                  boxSizing: "border-box",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Box display="flex" flex="1">
                                  <Box
                                    sx={{
                                      paddingLeft: 2,
                                      position: "relative",
                                      paddingRight: 3,
                                      flex: 1,
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      color={palette.common.black}
                                      sx={{
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {job?.name}
                                    </Typography>
                                    <Typography
                                      variant="subtitle2"
                                      color={palette.gray.darkest}
                                      sx={{
                                        fontSize: "12px",
                                        fontWeight: 400,
                                      }}
                                    >
                                      {job?.key}
                                    </Typography>
                                    <CloseIcon
                                      sx={{
                                        position: "absolute",
                                        right: "0",
                                        top: "0",
                                        cursor: "pointer",
                                        width: "20px",
                                        height: "20px",
                                        color: palette.gray.dark,
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </Paper>
                            </Grid>
                          ))}
                          <DOCLink
                            sx={{ mb: 2 }}
                            name="Open engine console"
                            href="#"
                          />
                        </>
                      ) : (
                        <Typography
                          mb={2}
                          variant="h5"
                          color={palette.error.dark}
                          sx={{
                            fontSize: "14px",
                            lineHeight: "20px",
                            fontWeight: "400",
                          }}
                        >
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: "16px",
                              lineHeight: "20px",
                              display: "inline-block",
                              verticalAlign: "middle",
                              marginRight: "3px",
                              marginBottom: "3px",
                              color: palette.error.dark,
                            }}
                          />
                          No schema defined
                        </Typography>
                      )}
                    </Grid>
                    <Button
                      color="grayAccent"
                      variant="contained"
                      onClick={() => setToggleSelectJob(true)}
                    >
                      Select job
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
            <Box mb={6} display="flex" flexDirection="column">
              <Typography
                mb={2}
                variant="h6"
                color={palette.common.black}
                sx={{ fontWeight: "400" }}
              >
                Source
              </Typography>
              <Box
                display="flex"
                mb={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Label
                  value="Transformation code URL"
                  variant="body1"
                  sx={{
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    color: palette.common.black,
                    mb: 1,
                  }}
                  info
                />
              </Box>
              <CustomTextField
                name="sourceUrl"
                value={values.sourceUrl}
                onChange={handleChange}
                error={errors.sourceUrl}
                touched={touched.sourceUrl}
              />
            </Box>
          </Box>

          {toggleSelectJob && <SelectJobModal />}
          {toggleOffPlateformTransformation && (
            <OffPlateformTransformationEngineModal />
          )}
          <Box>
            <Button
              color="primary"
              variant="contained"
              sx={{ width: "100%", marginBottom: "10px" }}
              onClick={(e) => handleSubmit()}
            >
              Save
            </Button>
            <Button
              color="grayAccent"
              variant="outlined"
              sx={{ width: "100%" }}
              onClick={toggleRightSidePanel}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      )}
    </Formik>
  );
};
